import { useEffect, useState } from "react"

import type { RefObject } from "react"

export function useElementHeight(ref: RefObject<HTMLElement | null>, initial = 120, deps: unknown[] = []) {
  const [height, setHeight] = useState(initial)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        setHeight(entry.contentRect.height)
      }
    })

    resizeObserver.observe(element)

    setHeight(element.offsetHeight)

    return () => resizeObserver.disconnect()
  }, [ref.current, ...deps]) // eslint-disable-line react-hooks/exhaustive-deps

  return height
}
